import { render, staticRenderFns } from "./APP_informationInfo.vue?vue&type=template&id=793870cc&scoped=true&"
import script from "./APP_informationInfo.vue?vue&type=script&lang=js&"
export * from "./APP_informationInfo.vue?vue&type=script&lang=js&"
import style0 from "./APP_informationInfo.vue?vue&type=style&index=0&id=793870cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793870cc",
  null
  
)

export default component.exports